<template>
  <div class="review page">
    <div class="page-header">
      <div class="container">
        <h1 class="title">{{ $t('pagetitle.overview') }}</h1>
      </div>
    </div>
    <div class="page-body" v-loading="loading">
      <div class="container">
        <div class="address">
          <h1 class="title">{{ $t('title.delivery') }}</h1>
          <div class="address-row">
            <div class="item" v-for="(address, index) in addresses" :key="index" :class="{ 'active': selectedIndex === index }" @click="onAddressSelect(address)">
              <div class="item-padding">
                <div class="item-title">
                  <span v-if="selectedIndex === index">{{ $t('button.sendto') }}</span>
                </div>
                <div class="item-desc">
                  <h2 style="font-weight: bold">{{ address.branch }}</h2>
                  <h2>{{ address.address1 }}</h2>
                  <h2 v-if="address.address2">{{ address.address2 }}</h2>
                  <h2>{{ address.postcode }}, {{ address.city }}</h2>
                  <h2>{{ address.state }}, {{ address.country }}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-row class="product">
          <div class="cartrow">
            <div class="cart-box">
              <h1 class="title">{{ $t('title.products') }}</h1>
              <div class="main-col">
                <el-row class="product-list" v-for="(inv, index) in inventory" :key="index">
                  <div class="product-index">
                    <span class="text">{{ index + 1 }}</span>
                  </div>
                  <img :src="inv.beer.beer_image ? inv.beer.beer_image.path : '/static/beer-placeholder.jpg'" />
                  <div class="product-desc">
                    <div class="product-name">
                      <span class="title">{{ inv.beer.description }}</span>
                      <span class="text">{{ inv.beer.description2 }}</span>
                      <span class="text" v-if="($mq.resize && $mq.below('767px'))">Qty: {{ inv.quantity }}</span>
                      <span class="text" v-if="($mq.resize && $mq.below('767px'))">Price: {{ $t('currency.malaysia') + inv.beer.totalprice }}</span>
                    </div>
                    <div class="product-col" v-if="!($mq.resize && $mq.below('767px'))">
                      <div class="product-qty">
                        <span class="title">Warehouse</span>
                        <span class="text">{{ inv.beer.stocks.branch.label }}</span>
                      </div>
                      <div class="product-qty">
                        <span class="title">Qty</span>
                        <span class="text">{{ inv.quantity }}</span>
                      </div>
                      <div class="product-price">
                        <span class="title">Price</span>
                        <span class="text">{{ $t('currency.malaysia') }} {{ inv.beer.totalprice }}</span>
                      </div>
                    </div>
                  </div>
                </el-row>
                <el-row class="product-list total">
                  <div class="total-row">
                    <span class="total-label">{{ $t('title.subtotal') + ':' }}</span>
                    <span v-if="data" class="total-title">{{ $t('currency.malaysia') + data.subTotal.toFixed(2) }}</span>
                  </div>
                  <!-- <div class="total-row">
                    <span class="total-label">{{ $t('title.gst') + ' ' + gstrate + '%: ' }}</span>
                    <span class="total-title">{{ $t('currency.malaysia') + gstamount.toFixed(2) }}</span>
                  </div> -->
                  <div class="total-row">
                    <span class="total-label">{{ $t('title.total') + ':' }}</span>
                    <span class="total-title">{{ $t('currency.malaysia') + totalamount.toFixed(2) }}</span>
                  </div>
                  <!-- <span class="title" v-if="gstamount">{{ $t('title.gst') + ' ' + gstrate + '% : ' + $t('currency.malaysia') + gstamount }}</span>
                  <span class="title">{{ $t('title.total') }}: {{ $t('currency.malaysia') }} {{ data.totalAmount }}</span> -->
                </el-row>
              </div>
            </div>
          </div>
          <el-row v-if="data" type="flex" justify="start">
            <span>Note: {{ data.note }}</span>
          </el-row>
          <el-row v-if="isError" type="flex" justify="center" class="error">
            <el-alert
              :title="$t('error.somethingwrong')"
              type="error"
              :closable="false"
              show-icon>
            </el-alert>
          </el-row>
          <el-row v-if="isError" type="flex" justify="center" class="error">
            <el-alert
              :title="'Message: ' + errorMsg"
              type="error"
              :closable="false"
              show-icon>
            </el-alert>
          </el-row>
          <el-row type="flex" justify="end" class="error">
            <span>{{ $t('subtitle.invoicenote') }}</span>
          </el-row>
          <el-row class="action">
            <el-button class="orange-button orange-button-reverse" @click="onSubmit($t('button.back'))">
              {{ $t('button.back') }}
            </el-button>
            <el-button class="orange-button" @click="onSubmit($t('button.confirm'))">
              {{ $t('button.confirm') }}
            </el-button>
          </el-row>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Site from '@/api/site'
import Common from '@/utils/common'
import JsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'cart',
  components: {
  },
  props: {
    data: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      loading: false,
      addresses: [],
      selectedIndex: 0,
      inventory: [],
      gstrate: 0,
      gstamount: 0,
      totalamount: 0,
      isError: false,
      errorMsg: undefined
    }
  },
  created () {
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      if (!this.data) {
        this.$router.replace({ name: this.$t('route.cart') })
        return
      }
      this.inventory = this.data.inventory
      // console.log(this.inventory)
      this.onGetAddress()
    },
    async onGetAddress () {
      try {
        this.loading = true
        const res = await Site.getAddressByUserId(this.$store.getters.id)
        this.addresses = res.result
        this.totalamount = this.data.subTotal
        this.loading = false
      } catch (e) {
        this.loading = false
        console.log(e)
      }
    },
    onAddressSelect (item) {
      this.addresses.forEach((address, index) => {
        if (address === item) {
          this.selectedIndex = index
        }
      })
    },
    async onSubmit (action) {
      if (action === this.$t('button.confirm')) {
        this.errorMsg = undefined
        const valid = this.validateDate()
        if (!valid) {
          this.isError = true
          return
        }
        try {
          const data = this.generateData()
          let id
          this.loading = true
          const res = await Site.createOrder(data)
          // Clean the cart TODO
          console.log(res)
          if (res.status === 'fail') {
            this.errorMsg = res.result
            return
          }
          id = res.result
          const resOrder = await Site.getUserOrderById({ id, userId: this.$store.getters.id })
          if (resOrder) {
            this.$store.dispatch('ClearNote')
            if (resOrder && resOrder.result) {
              resOrder.result.inventory.forEach((item) => {
                item.branchName = item.branch ? item.branch.label : ''
              })
              // console.log('resOrder.result', resOrder.result)
              this.generateInvoice(resOrder.result)
            }
          }
        } catch (e) {
          this.loading = false
          this.isCompleted = true
          this.isError = true
          console.log(e)
          console.log(e.response)
          console.log(e.response.data)
        }
      } else if (action === this.$t('button.back')) {
        this.$router.go(-1)
      }
    },
    validateDate () {
      if (!this.data.userId || !this.data.groupId || !this.data.email) {
        console.log('user, group or email validate failed')
        return false
      } else if (!this.data.inventory || this.data.inventory.length < 1) {
        console.log('inventory validate failed')
        return false
      } else if (!this.addresses || !this.addresses[this.selectedIndex].id) {
        console.log('error validate failed')
        return false
      }
      return true
    },
    generateData () {
      let formData = new FormData()
      if (this.data.file) {
        formData.append(this.data.file.name, this.data.file.raw, this.data.file.filename)
      }
      formData.append('userId', this.data.userId)
      formData.append('groupId', this.data.groupId)
      formData.append('email', this.data.email)
      formData.append('addressId', this.addresses[this.selectedIndex].id)
      // formData.append('totalAmount', this.data.totalAmount)
      formData.append('poNumber', this.data.poNumber)
      formData.append('note', this.data.note)
      this.data.inventory.forEach((val, index) => {
        formData.append('inventory[' + index + ']', val.beer.id)
        formData.append('quantity[' + index + ']', val.quantity)
        formData.append('branches[' + index + ']', val.beer.stocks.branches_id)
      })
      return formData
    },
    generateInvoice (data) {
      if (!data) {
        return
      }
      const deliverAddress = data.address
      const billingAddress = data.userinfo.billing
      billingAddress.companyName = data.userinfo.customer_name
      const orderList = data.inventory
      const orderSplitList = []
      let ordersplitpages = 0
      let splitcounter = 0
      const remark = data.note
      const totalamount = data.total_amount
      const finalamount = data.total_with_tax
      // const gstrate = data.gstrate
      orderList.forEach((od, index) => {
        od.listId = index + 1
        od.unit_price = od.unit_price.toFixed(2)
        od.price = od.price.toFixed(2)

        if (splitcounter < 15) {
          splitcounter++
        } else {
          splitcounter = 1
          ordersplitpages++
        }
        if (!orderSplitList[ordersplitpages]) {
          orderSplitList[ordersplitpages] = []
        }
        orderSplitList[ordersplitpages].push(od)
      })
      const locale = this.$moment(data.created_at + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY')
      const timestamp = this.$moment(data.created_at + ' +0000', 'YYYY-MM-DD HH:mm:ss Z').tz('Asia/Kuala_Lumpur').format('DD/MM/YYYY LTS')
      const poInfo = {
        number: data.po_number,
        currency: this.$t('currency.malaysia'),
        customernumber: data.userinfo.code,
        date: locale,
        term: data.userinfo.credit.name
      }
      const userInfo = {
        attn: data.userinfo.contact_person,
        tel: data.userinfo.phone_number,
        email: data.user.email
      }

      var doc = new JsPDF('p', 'pt')

      var comapnyJSON = {
        CompanyName: 'MYBEER (M) SDN BHD',
        CompanyGSTID: '001720393728',
        CompanyState: 'KUALA LUMPUR',
        CompanyCode: '(1015861-U)',
        CompanyAddressLine1: '1 Jalan Nagasari,',
        CompanyAddressLine2: '50200 KUALA LUMPUR',
        companyEmail: 'fin-mybeer@tapsgroup.my',
        companyPhone: '+603-6206-5983'
      }

      orderSplitList.forEach((objsplit, index) => {
        if (index > 0) {
          doc.addPage()
        }

        doc.setFont('times')
        doc.setFontType('bold')
        doc.setFontSize(17)
        doc.text(140, 30, comapnyJSON.CompanyName)

        doc.setFontSize(9)
        doc.text(328, 30, comapnyJSON.CompanyCode)

        doc.setFontType('normal')
        doc.text(140, 42, comapnyJSON.CompanyAddressLine1)
        doc.text(140, 52, comapnyJSON.CompanyAddressLine2)

        // doc.text(140, 62, 'Phone: ' + comapnyJSON.companyPhone)
        doc.text(140, 62, 'Email: ' + comapnyJSON.companyEmail)
        // doc.text(140, 72, 'GST ID: ' + comapnyJSON.CompanyGSTID)

        doc.setFontSize(17)
        doc.setFont('helvetica')
        doc.setFontType('bold')
        doc.text(540, 92, 'PURCHASE ORDER', null, null, 'right')

        doc.line(70, 102, 560, 102)

        doc.setFontSize(7)
        doc.setFontType('normal')
        doc.text(75, 122, 'BILL TO')
        doc.text(260, 122, 'DELIVER TO')

        doc.setFontSize(10)
        doc.setFontType('bold')
        doc.text(75, 135, billingAddress.companyName)
        doc.text(260, 135, deliverAddress.branch)

        doc.setFontType('normal')
        doc.setFontSize(8)

        let billToPostX = 75
        let addposY = 148
        doc.text(billToPostX, addposY, billingAddress.address1)
        if (billingAddress.address2) {
          addposY += 11
          doc.text(billToPostX, addposY, billingAddress.address2)
        }
        addposY += 11
        doc.text(billToPostX, addposY, billingAddress.city + ', ' + billingAddress.state)
        addposY += 11
        doc.text(billToPostX, addposY, billingAddress.postcode)

        let conPosY = 190
        let billInfoPosX = billToPostX + 25
        doc.text(billToPostX, conPosY, 'Attn')
        doc.text(billInfoPosX, conPosY, ': ' + userInfo.attn)
        conPosY += 11
        doc.text(billToPostX, conPosY, 'Tel')
        doc.text(billInfoPosX, conPosY, ': ' + userInfo.tel)
        conPosY += 11
        doc.text(billToPostX, conPosY, 'Email')
        doc.text(billInfoPosX, conPosY, ': ' + userInfo.email)

        // DELIVER TO
        let delToPostX = 260
        addposY = 148
        doc.text(delToPostX, addposY, deliverAddress.address1)
        if (deliverAddress.address2) {
          addposY += 11
          doc.text(delToPostX, addposY, deliverAddress.address2)
        }
        addposY += 11
        doc.text(delToPostX, addposY, deliverAddress.city + ', ' + deliverAddress.state)
        addposY += 11
        doc.text(delToPostX, addposY, deliverAddress.postcode)

        conPosY = 190
        billInfoPosX = delToPostX + 25
        doc.text(delToPostX, conPosY, 'Attn')
        doc.text(billInfoPosX, conPosY, ': ' + userInfo.attn)
        conPosY += 11
        doc.text(delToPostX, conPosY, 'Tel')
        doc.text(billInfoPosX, conPosY, ': ' + userInfo.tel)
        conPosY += 11
        doc.text(delToPostX, conPosY, 'Email')
        doc.text(billInfoPosX, conPosY, ': ' + userInfo.email)

        // RIGHT column
        let labelPosX = 430
        let labelPosY = 135
        let poInfoPosX = labelPosX + 70
        let labelGapX = 15
        doc.text(labelPosX, labelPosY, 'PO.NO')
        doc.text(poInfoPosX, labelPosY, ': ' + poInfo.number)
        labelPosY += labelGapX
        doc.text(labelPosX, labelPosY, 'CURRENCY')
        doc.text(poInfoPosX, labelPosY, ': ' + poInfo.currency)
        labelPosY += labelGapX
        doc.text(labelPosX, labelPosY, 'CUSTOMER NO')
        doc.text(poInfoPosX, labelPosY, ': ' + poInfo.customernumber)
        labelPosY += labelGapX
        doc.text(labelPosX, labelPosY, 'DATE')
        doc.text(poInfoPosX, labelPosY, ': ' + poInfo.date)
        labelPosY += labelGapX
        doc.text(labelPosX, labelPosY, 'TERM')
        doc.text(poInfoPosX, labelPosY, ': ' + poInfo.term)
        labelPosY += labelGapX
        doc.text(labelPosX, labelPosY, 'PAGE')
        let currentpage = index + 1
        doc.text(poInfoPosX, labelPosY, ': ' + currentpage + ' of ' + orderSplitList.length)

        let header = (data) => {
          doc.setFontSize(7)
          doc.setTextColor(40)
          doc.setFontStyle('normal')
        }

        let options = {
          addPageContent: header,
          theme: 'plain',
          styles: {
            overflow: 'linebreak',
            fontSize: 8,
            cellPadding: 4
          },
          headerStyles: {
            overflow: 'linebreak',
            fontSize: 7,
            halign: 'center'
          },
          columnStyles: {
            listId: {columnWidth: 30, halign: 'center'},
            code: {columnWidth: 40},
            description: {columnWidth: 150},
            description2: {columnWidth: 85, halign: 'center'},
            branchName: {columnWidth: 40, halign: 'center'},
            quantity: {columnWidth: 40, halign: 'center'},
            unitprice: {columnWidth: 55, halign: 'center'},
            subtotal: {columnWidth: 50, halign: 'center'}
          },
          tableWidth: 490,
          margin: {
            top: 80,
            left: 70
          },
          startX: 150,
          startY: 220
        }
        let columns = [
          {title: '#', dataKey: 'listId'},
          {title: 'ITEM CODE', dataKey: 'code'},
          {title: 'DESCRIPTION', dataKey: 'description'},
          {title: 'ITEM GROUP', dataKey: 'description2'},
          {title: 'WHOUSE', dataKey: 'branchName'},
          {title: 'QTY', dataKey: 'quantity'},
          {title: 'UNIT PRICE', dataKey: 'unit_price'},
          {title: 'SUB TOTAL', dataKey: 'price'}
        ]
        doc.autoTable(columns, objsplit, options)
        doc.setDrawColor(0)
        doc.rect(70, 220, 490, 25)
      })

      doc.line(70, 745, 560, 745)
      doc.line(70, 793, 560, 793)
      doc.setLineWidth(1)
      doc.line(70, 788, 560, 788)
      doc.setFontType('bold')
      doc.setFontSize(7)
      let remarkwrap = doc.splitTextToSize(remark, 250)
      doc.text(70, 693, 'REMARK :')
      doc.text(110, 693, remarkwrap)
      let wordpricewrap = doc.splitTextToSize(Common.convertNumberWithDecimal(totalamount.toFixed(2)), 250)
      doc.text(70, 758, 'RINGGIT MALAYSIA : ')
      doc.text(150, 758, wordpricewrap)
      doc.text(500, 758, 'Sub-Total :', null, null, 'right')
      doc.text(500, 782, 'Total Amount :', null, null, 'right')

      doc.text(550, 758, totalamount.toFixed(2), null, null, 'right')
      doc.text(550, 782, finalamount.toFixed(2), null, null, 'right')
      doc.text(550, 802, timestamp, null, null, 'right')

      // doc.setFontType('italic')
      // doc.setFontSize(6)
      // doc.text(70, 655, 'Terms & Conditions:')
      // doc.text(70, 665, '1. All goods contained in this purchase order, upon signing and acknowledgement of receipt.')

      // doc.save('invoice.pdf')
      const blob = doc.output('blob')
      const formData = new FormData()
      formData.append('files[0]', blob, poInfo.number + '.pdf')
      formData.append('id', data.id)
      Site.updateOrder(formData).then((res) => {
        const emaildata = { id: data.id, userId: this.$store.getters.id }
        return Site.emailOrder(emaildata)
      }).then(() => {
        this.$ls.remove('beers')
        return this.$store.dispatch('CleanBeer')
      }).then(() => {
        this.loading = false
        this.isCompleted = true
        this.$router.push({ name: 'Successful', params: { id: poInfo.number } })
      }).catch((err) => {
        this.tableLoading = false
        this.isError = true
        console.log(err.response.data)
      })
    }
  }
}
</script>
<style lang="scss">
.cart {
  // .el-form {
  //   padding-bottom: 25px;
  // }
  // .el-form-item__label {
  //   color: #1C1C1C;
  //   font-size: 18px;
  // }
  .el-form-item__label, .el-checkbox__label {
    color: #1C1C1C;
    font-size: 18px;
  }
  .el-input--medium .el-input__inner {
    height: 56px;
    line-height: 56px;
  }
  .el-input__inner, .el-textarea__inner, .el-checkbox__label {
    font-size: 18px;
    border-radius: 0px;
    padding: 10px 15px;
  }
}
</style>
<style lang="scss" scoped>
@import "@/styles/settings.scss";
.review {
  .container {
  }
  .page-body {
    background-color: $white-color;
  }
  .action {
    display: flex;
    justify-content: flex-end;
    padding: 20px 0;
  }
  .product {
    padding-bottom: 50px;
  }
  .error {
    margin-top: 15px;
  }
  .total {
    display: flex;
    justify-content: flex-end;
    flex-direction: column !important;
    .total-row {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 5px;
      &:last-child {
        padding-bottom: 0;
      }
    }
    & .total-title, & .total-label {
      color: $black-color;
      width: 150px;
      font-weight: bold;
      font-size: 20px;
      padding-right: 15px;
      text-align: right;
    }
    & > .title {
      font-weight: bold;
      padding-right: 15px;
      text-align: right;
    }
  }
  .product-list {
    display: flex;
    flex-direction: row;
    padding: 15px 0;
    border-bottom: 2px solid $gray-color;
    & > img {
      height: 100px;
      margin-right: 15px;
    }
    .product-index {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 50px;
    }
    .product-desc {
      display: flex;
      flex-direction: row;
      width: 100%;
      .title {
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 5px;
      }
      .product-qty, .product-price, .product-name {
        display: flex;
        flex-direction: column;
      }
      .product-name {
        width: 100%;
      }
      .product-qty {
        display: flex;
        align-items: center;
        width: 100px;
      }
      .product-price {
        display: flex;
        align-items: center;
        width: 150px;
      }
      .product-col {
        display: flex;
        flex-direction: row;
      }
    }
  }
  .address-row {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: row;
    flex-wrap: wrap;
    flex-flow: row wrap;
    align-content: flex-end;
    // column-count: 1;
    @media (min-width: 768px) {
      // column-count: 3;
    }
    .item {
      display: flex;
      width: 50%;

      @media (min-width: 768px) {
        width: 25%;
      }
      &.active {
        & > .item-padding {
          border-color: $orange-light-color;
          & .item-title {
            text-transform: uppercase;
            font-size: 14px;
            font-weight: bold;
            display: flex;
            justify-content: center;
            background-color: $orange-light-color;
            height: 16px;
            padding: 4px;
          }
        }
      }

      .item-padding {
        display: flex;
        flex-direction: column;
        width: 100%;
        border: 1px solid $gray-color;
        border-radius: 3px;
        background-color: $white-color;
        cursor: pointer;
        margin: 5px;
        & .item-title {
          display: flex;
          justify-content: center;
          background-color: $gray-color;
          height: 16px;
          padding: 4px;
        }
        & > .item-desc {
          padding: 5px 10px 10px 10px;
        }
      }
      h1 {
        font-size: 18px;
      }
      h2 {
        font-size: 16px;
        font-weight: normal;
        margin: 5px 0;
      }
      img {
        width: 100%;
        max-width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/cart/confirmation.vue